import { render } from "./LongFong.vue?vue&type=template&id=6e2cc314&scoped=true"
import script from "./LongFong.vue?vue&type=script&lang=js"
export * from "./LongFong.vue?vue&type=script&lang=js"

import "./LongFong.vue?vue&type=style&index=0&id=6e2cc314&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2cc314"]])

export default __exports__